import _extends from "@babel/runtime/helpers/extends";
import { Box, Button, Heading } from '@wix/design-system';
import { useIsMobile } from '@wix/core-domain-search';
import { DomainSearchSuiteModule, SearchRecommendationLayout } from '@wix/domains-search-suite';
import React, { useContext, useEffect, useRef } from 'react';
import { PRE_SUGGESTIONS_FALLBACK_QUERY, usePreSuggestions } from '../../hooks/usePreSuggestions';
import { LazyRecommendationLabel } from '../LazyRecommedationLabel/LazyRecommendationLabel';
import styles from './preSuggestionsOptimized.scss';
const CardActionContext = /*#__PURE__*/React.createContext(undefined);
const CardDomainContext = /*#__PURE__*/React.createContext(undefined);
const PreSuggestionsOptimizedLayout = {
  SearchRecommendationListContainer: _ref => {
    let {
      children,
      ...props
    } = _ref;
    const isMobile = useIsMobile();
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: isMobile ? 'vertical' : 'horizontal',
      display: "flex",
      width: "100%",
      gap: "16px"
    }, !isMobile && {
      flexWrap: 'wrap'
    }, {
      paddingBottom: "12px"
    }, props), children);
  },
  SearchRecommendationContainer: _ref2 => {
    let {
      children,
      className,
      dataHook
    } = _ref2;
    const domainRef = useRef();
    const cardAction = useContext(CardActionContext);
    const handleCardClick = () => {
      const recommendation = cardAction == null ? void 0 : cardAction.recommendations.find(_ref3 => {
        let {
          domain
        } = _ref3;
        return domain === domainRef.current;
      });
      if (!cardAction || cardAction.disabled || !recommendation) {
        return;
      }
      void cardAction.onGetItClick(recommendation);
    };
    return /*#__PURE__*/React.createElement(CardDomainContext.Provider, {
      value: domainRef
    }, /*#__PURE__*/React.createElement("div", {
      className: [styles.card, className].filter(Boolean).join(' '),
      "data-hook": dataHook,
      onClick: handleCardClick
    }, children));
  },
  SearchRecommendationSkeletonContainer: _ref4 => {
    let {
      children
    } = _ref4;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.card
    }, children);
  },
  DomainInfoContainer: _ref5 => {
    let {
      children,
      ...props
    } = _ref5;
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      gap: "12px"
    }, props), children);
  },
  Skeleton: () => /*#__PURE__*/React.createElement(SearchRecommendationLayout.Skeleton, {
    limit: 3
  }),
  Label: props => /*#__PURE__*/React.createElement(SearchRecommendationLayout.Label, _extends({}, props, {
    primary: true,
    className: styles.premiumBadge
  })),
  GetItButtonContainer: _ref6 => {
    let {
      children
    } = _ref6;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.getItButton,
      onClick: event => event.stopPropagation()
    }, children);
  },
  GetItButton: _ref7 => {
    let {
      children,
      ...props
    } = _ref7;
    return /*#__PURE__*/React.createElement(Button, _extends({
      size: "medium",
      skin: "dark"
    }, props, {
      priority: "primary"
    }), children);
  },
  TitleDisplay: props => {
    const domainRef = useContext(CardDomainContext);
    useEffect(() => {
      if (domainRef) {
        domainRef.current = props.title;
      }
    }, [domainRef, props.title]);
    return /*#__PURE__*/React.createElement(Heading, {
      size: "large",
      className: styles.domainTitle
    }, props.title);
  },
  Divider: () => /*#__PURE__*/React.createElement(React.Fragment, null),
  HoverBox: _ref8 => {
    let {
      children,
      ...props
    } = _ref8;
    return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
      flex: 1,
      className: ""
    }), children);
  },
  ActionsContainer: _ref9 => {
    let {
      children,
      ...props
    } = _ref9;
    return /*#__PURE__*/React.createElement(Box, _extends({
      gap: "24px",
      verticalAlign: "middle",
      align: "space-between"
    }, props), children);
  },
  PricingWrapper: _ref10 => {
    let {
      children,
      ...props
    } = _ref10;
    return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
      gap: "4px",
      align: "left",
      className: styles.pricing
    }), children);
  }
};
export const PreSuggestionsOptimized = function (_temp) {
  let {
    fallbackQuery = PRE_SUGGESTIONS_FALLBACK_QUERY
  } = _temp === void 0 ? {} : _temp;
  const {
    recommendations,
    isLoading,
    isPricingLoading,
    matchLabels,
    isLoadingLabels,
    disabled,
    hidden,
    onGetItClick
  } = usePreSuggestions(fallbackQuery);
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center"
  }, /*#__PURE__*/React.createElement(CardActionContext.Provider, {
    value: {
      recommendations,
      disabled,
      onGetItClick
    }
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.SearchRecommendationList, {
    items: recommendations,
    isLoading: isLoading,
    isPricingLoading: isPricingLoading,
    Layouts: {
      ...PreSuggestionsOptimizedLayout,
      LabelContainer: LazyRecommendationLabel({
        isLoading: isLoadingLabels,
        matchLabels,
        primary: true,
        labelClassName: styles.premiumBadge
      })
    },
    disabled: disabled,
    onClickGetIt: onGetItClick,
    firstSuggestionPrimary: false
  })));
};
//# sourceMappingURL=PreSuggestionsOptimized.js.map